export const intentTypes: Array<{ title: string; value: string }> = [
	{
		title: "StartCall",
		value: "StartCall",
	},
	{
		title: "StartChat",
		value: "StartChat",
	},
	{
		title: "ViewChart",
		value: "ViewChart",
	},
	{
		title: "ViewContact",
		value: "ViewContact",
	},
	{
		title: "ViewQuote",
		value: "ViewQuote",
	},
	{
		title: "ViewNews",
		value: "ViewNews",
	},
	{
		title: "ViewAnalysis",
		value: "ViewAnalysis",
	},
	{
		title: "ViewInstrument",
		value: "ViewInstrument",
	},
];
